import RestApiModel from "@/api/Model/RestApiModel";

class ReportType extends RestApiModel {
  static getResourceEndpoint() {
    return '/company-report-types';
  }
}

export default ReportType;
